import Phaser from 'phaser';
import dimensions from '../dimensions';
import utils from '../utils';
import sounds from '../sounds';
import DialogueBox from '../objects/DialogueBox';
import PauseWindow from '../objects/PauseWindow';
import Button from '../objects/ui/Button';

export default class GameState extends Phaser.State {
    init() {
        this.currentSet = [];

        for (let i = 1; i <= this.game.currentMission; i++) {
            for (let j = 0; j <= (i == this.game.currentMission ? this.game.currentLevel : GameConfig.letters["Mission" + i].length - 1); j++) {
                this.currentSet = this.currentSet.concat(GameConfig.letters["Mission" + i][j]);
            }
        }

        this.mode = this.game.currentDifficulty;
    }

    create() {
        this.setGameScale();
        this.createSounds();
        this.createInput();

        this.stage.backgroundColor = '#000000';
        this.game.gameState = this;

        this.supergroup = this.game.add.group();
        this.gameGroup = this.game.add.group();
        this.supergroup.add(this.gameGroup);
        this.game.time.advancedTiming = true;

        this.bg = this.game.add.sprite(dimensions.gameWidth / 2, dimensions.gameHeight / 2, "bg_mission_" + this.game.currentMission + "_" + (this.game.currentLevel + 1));
        this.bg.anchor.set(0.5);
        this.gameGroup.add(this.bg);

        this.bg.originalWidth = this.bg.width;
        this.bg.originalHeight = this.bg.height;

        this.createEnvironment();

        this.pauseWindow = new PauseWindow(this.game, this.game.add.group());
        this.gameGroup.add(this.pauseWindow);

        this.backButton = new Button(this.game, this.gameGroup, "mission-button", "<-", 70, function () {
            this.pauseWindow.show();
        }.bind(this));
        this.backButton.x = 100;
        this.backButton.y = dimensions.gameHeight - 50;
        this.backButton.scale.set(0.5);
        this.backButton.visible = false;

        this.setPositions();
        this.scale.setResizeCallback(this.gameResized, this);
        this.game.onBlur.add(this.onPause, this);
        this.game.onFocus.add(this.onResume, this);

        this.gameResized();
        this.loaded = false;

        this.showDialogue();

        sounds.menuMusic.stop();
    }

    onPause() {
        this.game.sound.pauseAll();
    }

    onResume() {
        this.game.sound.resumeAll();
    }

    showDialogue() {
        this.nextDialogue();
    }

    nextDialogue() {
        if (this.script[this.scriptNo]) {
            this.currentDialogue = new DialogueBox(this.game, this.game.add.group(), this.script[this.scriptNo], this.nextDialogue.bind(this), this.scriptNo === 0 ? "entry" : this.scriptNo == this.script.length - 1 ? "exit" : "none");
            this.gameGroup.add(this.currentDialogue);

            this.scriptNo++;
        } else {
            this.showIntro();
        }
    }

    showIntro() {
        let countdown = 3;

        let countdownText = this.game.add.bitmapText(dimensions.gameWidth / 2, dimensions.gameHeight / 2, "font-countdown", "3", 200);
        countdownText.anchor.set(0.5);
        this.gameGroup.add(countdownText);

        sounds.countdown.play();

        this.game.time.events.loop(1000, function () {
            countdown--;

            if (countdown === -1) {
                countdownText.destroy();
                this.game.time.events.removeAll();
                this.backButton.visible = true;
                this.startGame();
            } else if (countdown === 0) {
                countdownText.text = "Go!";
            } else {
                countdownText.text = countdown;
            }
        }.bind(this));
    }

    startGame() {}

    endGame() {}

    pressKey(input) {}

    update() {}

    createEnvironment() {}

    createInput() {
        let self = this;
        this.game.input.keyboard.onUpCallback = function (e) {
            self.pressKey(e);
        };
    }

    removeInput() {
        this.game.input.keyboard.onUpCallback = null;
    }

    createSounds() {}

    gameResized() {
        let ratio = 1;

        if (window.screen.systemXDPI !== undefined && window.screen.logicalXDPI !== undefined && window.screen.systemXDPI > window.screen.logicalXDPI) ratio = window.screen.systemXDPI / window.screen.logicalXDPI;else if (window.devicePixelRatio !== undefined) ratio = window.devicePixelRatio;

        dimensions.fullWidth = window.innerWidth * ratio;
        dimensions.fullHeight = window.innerHeight * ratio;

        if (this.game.width === dimensions.fullWidth && this.game.height === dimensions.fullHeight) return;

        this.game.scale.setGameSize(dimensions.fullWidth, dimensions.fullHeight);

        this.setGameScale();
        this.setPositions();
    }

    setGameScale() {
        let scaleX = dimensions.fullWidth / dimensions.gameWidth;
        let scaleY = dimensions.fullHeight / dimensions.gameHeight;

        this.gameScale = scaleX < scaleY ? scaleX : scaleY;

        dimensions.actualWidth = this.game.width / this.gameScale;
        dimensions.actualHeight = this.game.height / this.gameScale;
        dimensions.viewWidth = dimensions.actualWidth;
        dimensions.viewHeight = 764;
    }

    setPositions() {
        this.supergroup.scale.set(this.gameScale);
        this.gameGroup.x = (this.game.width / this.gameScale - dimensions.gameWidth) / 2;

        let scaleX = dimensions.actualWidth / this.bg.originalWidth;
        let scaleY = dimensions.actualHeight / this.bg.originalHeight;
        let scale = Math.max(scaleX, scaleY);

        this.bg.scale.set(scale);
        this.bg.y = dimensions.actualHeight / 2;
    }

    offsetMouse() {
        return { x: this.game.input.x * dimensions.actualWidth / this.game.width + (dimensions.gameWidth - dimensions.actualWidth) / 2,
            y: this.game.input.y * dimensions.actualHeight / this.game.height };
    }

    offsetWorld(point) {
        return { x: point.x * dimensions.actualWidth / this.game.width, y: point.y * dimensions.actualHeight / this.game.height };
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/states/Game.js
// module id = 103
// module chunks = 0